export default __webpack_public_path__ + "static/media/SINUS-INFECTION.10707e38.png";